function should() {
    return (
        typeof window.Intl === 'undefined' ||
        typeof window.IntersectionObserver === 'undefined' ||
        typeof window.ResizeObserver === 'undefined'
    );
}

export default should;
